import './PlayerProfile.css';
import PlayerProfile from './PlayerProfile';
export default PlayerProfile;



// WEBPACK FOOTER //
// ./src/components/Game/components/PlayerProfile/index.js